import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=edea7d42&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Index.vue?vue&type=style&index=1&id=edea7d42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!/////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edea7d42",
  null
  
)

export default component.exports